import { TFunction } from 'next-i18next';
import { routes } from '@/infrastructure/const/routes';
import { ILinkGroup } from '@/infrastructure/interfaces/i-link';

export const expansionPanelLinks = (t: TFunction): ILinkGroup[] => {
  return [
    {
      title: t('duaaRuqia'),
      items: [
        {
          title: t('duaa'),
          path: routes.duaa,
        },
        {
          title: t('ruqia'),
          path: routes.ruqia,
        },
      ],
    },
    {
      title: t('mostPopularFavorites'),
      items: [
        {
          title: t('mostPopular'),
          path: routes.mostPopular,
        },
        {
          title: t('myFavorite'),
          path: routes.myFavorite,
          authorized: true,
        },
      ],
    },
  ];
};
